export default __webpack_public_path__ + "static/media/process1.85f09adc.png";